<script>
import validate from "../../utils/validator";

export default {
  components: {},
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    type: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "",
    },
    inputClass: {},

    error_message: {
      type: String,
    },

    rules: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
    },

    iconRight: {
      type: Boolean,
      default: false,
    },
    directionRow: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      required: true,
    },
  },
  mounted() {},
  data() {
    return {
      focus_status: false,
    };
  },
  emits: ["update:modelValue"],
  methods: {
    validate,
  },

  computed: {},
};
</script>

